import { Injectable, Query } from '@angular/core';
import { AngularFireDatabase, AngularFireList, snapshotChanges } from '@angular/fire/compat/database';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable, observable, forkJoin, from, } from 'rxjs';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DeviceidService } from './deviceid.service';


@Injectable()
export class ChartService {

    userId = '';

    constructor(private fireDb: AngularFireDatabase, private fireAuth: AngularFireAuth, private router: Router,
        private toastr: ToastrService, private deviceIdService: DeviceidService) {
        // get the deviceId from home screen
        this.deviceIdService.currentDeviceId.subscribe(id => {
            this.deviceId = id;
            if (this.deviceId === 'ESP2635206COPY') {
                this.deviceId = 'ESP2635206';
            }
        });
        this.fireAuth.user.subscribe(user => {
            this.userId = user.uid;
        });
    }

    // 2AS devices list
    devices2ASList = ['ESP2653514', 'ESP11189971', 'ESP6135169', 'ESP2635206', 'ESP3653905', 'ESP6920199',
        'ESP2633947', 'ESP2635206COPY'];


    get currentUserObservable(): any {
        return this.fireAuth.authState;
    }
    deviceId: string;


    toDate = ((millis: number) => {
        const d = new Date(millis);
        return d.toLocaleDateString('fr-FR') + ' à ' + d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
    });

    getUserId() {
        return this.userId;
    }

    async getdecicetest(): Promise<any> {
        let dId = '';
        await this.deviceIdService.currentDeviceId.subscribe(id => {
            // console.log("im in subscribe of getdevicetest() !")
            dId = id;
        });
        return dId;
    }

    getChartData(): Observable<any> {
        return this.fireDb.list('/' + this.deviceId + '/jsonvaleur').valueChanges();

    }

    // get the last 12 hours values
    async getHalfDay() {
        const now = (new Date()).getTime();
        const halfDayData: Array<any> = [];
        const snap = await this.fireDb.list('/' + this.deviceId + '/jsonvaleur')
            .query.orderByChild('time').startAt(now - 43200000).once('value');
        snap.forEach(mesure => {
            halfDayData.push({
                temp: mesure.val().temp,
                hum: mesure.val().hum,
                time: mesure.val().time,
            });
        });
        halfDayData.splice(-1, 1);
        return halfDayData;
    }
    // get the last 24 hours values
    async getFullDay(): Promise<any> {
        const now = (new Date()).getTime();
        const fullDayData: Array<any> = [];
        const snap = await this.fireDb.list('/' + this.deviceId + '/jsonvaleur')
            .query.orderByChild('time').endAt(now - 86400000).once('value');
        snap.forEach(mesure => {
            fullDayData.push({
                temp: mesure.val().temp,
                hum: mesure.val().hum,
                time: mesure.val().time,
            });
        });
        fullDayData.splice(-1, 1);
        return fullDayData;

    }

    // get chart data unless last mesure
    async getChartData2(): Promise<any> {
        const dataArray: Array<any> = [];
        const snap = await this.fireDb.database.ref('/' + this.deviceId + '/jsonvaleur').once('value');
        snap.forEach(mesure => {
            dataArray.push({
                temp: mesure.val().temp,
                hum: mesure.val().hum,
                time: mesure.val().time
            });
        });
        // console.log("dataArray.length : " + dataArray.length)
        dataArray.splice(-1, 1);
        // console.log("dataArray.length : " + dataArray.length)
        return dataArray;
    }

    // get the last values
    getLastValue() {
        return this.fireDb.object('/' + this.deviceId + '/jsonvaleur').query.orderByChild('time').limitToLast(1);
    }

    // Get last nb Values
    getLastNbValues(nbValues: number, idDevice?: string) {
        if (idDevice) {
            return this.fireDb.database.ref('/' + idDevice + '/jsonvaleur').orderByChild('time').limitToLast(nbValues);
        }
        return this.fireDb.database.ref('/' + this.deviceId + '/jsonvaleur').orderByChild('time').limitToLast(nbValues);
    }


    // 2AS Calculate moy of the hour
    async getLastNbValuesByHour(nbValues: number) {
        const dataToReturn = {};
        await this.fireDb.database.ref('/' + this.deviceId + '/jsonvaleur').orderByChild('time')
            .limitToLast(nbValues).once('value').then(snapShot => {
                if (snapShot.exists()) {
                    snapShot.forEach(measure => {
                        const dateOfMeasure = new Date(measure.val().time);
                        const hour = dateOfMeasure.getHours();
                        const day = dateOfMeasure.getDate();
                        const month = dateOfMeasure.getMonth();
                        const year = dateOfMeasure.getFullYear();
                        const millisHour = new Date(year, month, day, hour).getTime();
                        if (dataToReturn[millisHour + ''] == null) {
                            dataToReturn[millisHour + ''] = {};
                            dataToReturn[millisHour + '']['hum'] = measure.val().hum;
                            dataToReturn[millisHour + '']['temp'] = measure.val().temp;
                        } else {
                            dataToReturn[millisHour + '']['hum'] =
                                (measure.val().hum + dataToReturn[millisHour + '']['hum']) / 2;
                            dataToReturn[millisHour + '']['temp'] =
                                (measure.val().temp + dataToReturn[millisHour + '']['temp']) / 2;
                        }
                    });
                }
            });
        return dataToReturn;
    }


    getHistoryMesures(nb: number, idDevice?: string) {
        if (idDevice) {
            return this.fireDb.list('/' + idDevice + '/jsonvaleur').query;
        }
        return this.fireDb.list('/' + this.deviceId + '/jsonvaleur').query;
    }


    // 2AS get history measures by hour
    async getHistoryMeasuresByhour(nb: number) {
        const dataObject = {};
        const arrayToReturn = [];
        await this.fireDb.database.ref('/' + this.deviceId + '/jsonvaleur').orderByChild('time')
            .once('value').then(snapShot => {
                if (snapShot.exists()) {
                    snapShot.forEach(measure => {
                        const dateOfMeasure = new Date(measure.val().time);
                        const hour = dateOfMeasure.getHours();
                        const day = dateOfMeasure.getDate();
                        const month = dateOfMeasure.getMonth();
                        const year = dateOfMeasure.getFullYear();
                        const millisHour = new Date(year, month, day, hour).getTime();
                        if (dataObject[millisHour + ''] == null) {
                            dataObject[millisHour + ''] = {};
                            dataObject[millisHour + '']['hum'] = measure.val().hum;
                            dataObject[millisHour + '']['temp'] = measure.val().temp;
                        } else {
                            dataObject[millisHour + '']['hum'] =
                                (measure.val().hum + dataObject[millisHour + '']['hum']) / 2;
                            dataObject[millisHour + '']['temp'] =
                                (measure.val().temp + dataObject[millisHour + '']['temp']) / 2;
                        }
                    });
                }
            });
        for (const keyMillis of Object.keys(dataObject)) {
            arrayToReturn.push({
                temp: dataObject[keyMillis]['temp'],
                hum: dataObject[keyMillis]['hum'],
                date: +keyMillis
            });
        }
        return arrayToReturn;
    }

    // get the numbers of jsonvaleur (to avoid the infinite loading of history)
    async getJsonValeurNumber(): Promise<any> {
        const snap = await this.fireDb.database.ref('/' + this.deviceId + '/LAST/compteur').once('value');
        if (snap.exists()) {
            return snap.val();
        } else {
            return 0;
        }
    }


    getChartSetting(idDevice?: string): Observable<any> {
        if (idDevice) {
            return this.fireDb.object('/' + idDevice + '/setting').valueChanges();
        }
        return this.fireDb.object('/' + this.deviceId + '/setting').valueChanges();
    }



    getChartMaxHum(idDevice?: string): Observable<any> {
        if (idDevice) {
            return this.fireDb.object('/' + idDevice + '/LAST/maxHum').valueChanges();
        }
        return this.fireDb.object('/' + this.deviceId + '/LAST/maxHum').valueChanges();
    }



    getChartMaxTemp(idDEvice?: string): Observable<any> {
        if (idDEvice) {
            return this.fireDb.object('/' + idDEvice + '/LAST/maxTemp').valueChanges();
        }
        return this.fireDb.object('/' + this.deviceId + '/LAST/maxTemp').valueChanges();
    }



    getChartMinHum(idDevice?: string): Observable<any> {
        if (idDevice) {
            return this.fireDb.object('/' + idDevice + '/LAST/minHum').valueChanges();
        }
        return this.fireDb.object('/' + this.deviceId + '/LAST/minHum').valueChanges();
    }



    getChartMinTemp(idDevice?: String): Observable<any> {
        if (idDevice) {
            return this.fireDb.object('/' + idDevice + '/LAST/minTemp').valueChanges();
        }
        return this.fireDb.object('/' + this.deviceId + '/LAST/minTemp').valueChanges();
    }

    // Restart max
    restartMaxValue(lastTemp, lastHum, lastTime, idDevice?: string) {
        if (idDevice) {
            this.fireDb.database.ref('/' + idDevice + '/LAST/').update({
                maxHum: {
                    date: lastTime,
                    hum: lastHum
                },
                maxTemp: {
                    date: lastTime,
                    temp: lastTemp
                },
                minHum: {
                    date: lastTime,
                    hum: lastHum
                },
                minTemp: {
                    date: lastTime,
                    temp: lastTemp
                }
            }).catch(err => { console.error(err); });
        } else {
            this.fireDb.database.ref('/' + this.deviceId + '/LAST/').update({
                maxHum: {
                    date: lastTime,
                    hum: lastHum
                },
                maxTemp: {
                    date: lastTime,
                    temp: lastTemp
                },
                minHum: {
                    date: lastTime,
                    hum: lastHum
                },
                minTemp: {
                    date: lastTime,
                    temp: lastTemp
                }
            }).catch(err => { console.error(err); });
        }

    }

    getChartLastValues(idDevice?: string): Observable<any> {
        if (idDevice) {
            return this.fireDb.object('/' + idDevice + '/LAST/lastValue').valueChanges();
        }
        return this.fireDb.object('/' + this.deviceId + '/LAST/lastValue').valueChanges();
    }

    getNumberNewNotifications(): Observable<any> {
        return this.fireDb.object('/' + this.deviceId + '/LAST/newNotifs').valueChanges();
    }
    getNumberNewConnectNotifications(): Observable<any> {
        return this.fireDb.object('/' + this.deviceId + '/LAST/newConnectionNotifs').valueChanges();
    }

    // set the number of new notification to 0
    makeConnectivityNotificationsRead() {
        this.fireDb.database.ref('/' + this.deviceId + '/LAST/newConnectionNotifs').transaction(nbN => 0);
    }


    async saveSettingsToDatabase(freq, maxTemp, minTemp, maxHum, minHum, name, calibT, calibHum, notifOn,
        telList: Array<any>, emailList: Array<any>, notifAuto?: boolean, notifDays?: Array<boolean>,
        notifBegin?: { minute: number, hour: number }, notifEnd?: { minute: number, hour: number },
        calibrationTime?: number) {

        // Make all tel inputs a number
        if (telList != null) {
            for (let i = 0; i < telList.length; i++) {
                telList[i] = (telList[i] == null || telList[i] === '') ? null : +telList[i];
            }
        }


        if (typeof (freq) !== undefined && freq !== null && freq !== '' && freq !== 0 && !isNaN(freq)) {
            // console.log("freq=" + freq)
            await this.fireDb.database.ref('/' + this.deviceId + '/setting').update({
                'f': freq
            });
        }
        if (typeof (maxTemp) !== 'undefined' && maxTemp !== null && maxTemp !== '' && typeof maxTemp === 'number') {
            await this.fireDb.database.ref('/' + this.deviceId + '/setting').update({
                'seuilMaxTemp': maxTemp
            });
        }
        if (typeof (minTemp) !== 'undefined' && minTemp !== null && minTemp !== '' && typeof minTemp === 'number') {
            await this.fireDb.database.ref('/' + this.deviceId + '/setting').update({
                'seuilMinTemp': minTemp
            });
        }
        if ((typeof (maxHum) !== 'undefined') && (maxHum !== null) && (maxHum !== '') && typeof maxHum === 'number') {
            // console.log('max humidity =' + maxHum)
            await this.fireDb.database.ref('/' + this.deviceId + '/setting').update({
                'seuilMaxHum': maxHum
            });
        }
        if (typeof (minHum) !== 'undefined' && minHum !== null && minHum !== '' && typeof minHum === 'number') {
            await this.fireDb.database.ref('/' + this.deviceId + '/setting').update({
                'seuilMinHum': minHum
            });
        }



        if (typeof (name) !== 'undefined' && name !== null && name !== '') {
            await this.fireDb.database.ref('/' + this.deviceId + '/setting').update({
                'deviceName': name
            });
        }
        if (typeof (calibT) === 'number' && calibT !== null) {
            await this.fireDb.database.ref('/' + this.deviceId + '/setting').update({
                'calibrationTemp': calibT
            });
        }
        if (typeof (calibHum) === 'number' && calibHum !== null) {
            await this.fireDb.database.ref('/' + this.deviceId + '/setting').update({
                'calibrationHum': calibHum
            });
        }
        if (typeof (notifOn) === 'boolean' && notifOn !== null) {
            await this.fireDb.database.ref('/' + this.deviceId + '/setting').update({
                'showNotif': notifOn
            });
        }
        if (telList != null) {
            await this.fireDb.database.ref('/' + this.deviceId + '/setting').update({
                'tel': telList
            });
        }
        if (emailList != null) {
            await this.fireDb.database.ref('/' + this.deviceId + '/setting').update({
                'email': emailList
            });
        }
        /** 2AS */
        if (notifDays) {
            await this.fireDb.database.ref(`/${this.deviceId}/setting/2AS/notification`).set({
                auto: notifAuto,
                days: notifDays,
                hours: {
                    beginH: notifBegin.hour,
                    beginM: notifBegin.minute,
                    endH: notifEnd.hour,
                    endM: notifEnd.minute
                }
            });
            await this.fireDb.database.ref(`/${this.deviceId}/setting/2AS/calibration`).set({
                date: calibrationTime
            });
        }
        /** ./2AS */
        return;
    }



    saveSetPointsToDatabase(tSetPoint, hSetPoint) {
        if (typeof (tSetPoint) !== 'undefined' && tSetPoint !== null && tSetPoint !== '' && typeof tSetPoint === 'number') {
            // console.log("freq=" + freq)
            this.fireDb.database.ref('/' + this.deviceId + '/setting').update({
                'tSetPoint': tSetPoint
            });
        }
        if (typeof (hSetPoint) !== 'undefined' && hSetPoint !== null && hSetPoint !== '' && typeof hSetPoint === 'number') {
            this.fireDb.database.ref('/' + this.deviceId + '/setting').update({
                'hSetPoint': hSetPoint
            });
        }
    }

    resetConsigne() {
        const now = new Date().getTime();
        return this.fireDb.database.ref('/' + this.deviceId + '/LAST').update({
            'setPointTEnd': 0,
            'setPointTRun': now,
            'setPointHEnd': 0,
            'setPointHRun': now,
        });
    }

    getLast(): Observable<any> {
        return this.fireDb.object('/' + this.deviceId + '/LAST').valueChanges();
    }



    getNotifications() {
        return this.fireDb.list('/' + this.deviceId + '/notification').valueChanges();
    }
    getAllNotificationsOld() {
        return this.fireDb.list('/' + this.deviceId + '/notification').snapshotChanges();
    }
    getAllNotifications() {
        return this.fireDb.list('/' + this.deviceId + '/notification').query;
    }

    // get last n notifications to enhance the application.
    getLastNNotifications(notifNumber, firstKey?) {

        if (firstKey) {
            return this.fireDb.list('/' + this.deviceId + '/notification')
                .query.orderByKey().endAt(firstKey).limitToLast(notifNumber + 1);
        }
        return this.fireDb.list('/' + this.deviceId + '/notification')
            .query.orderByKey().limitToLast(notifNumber);

    }

    // for history PDF generator
    async getMesure(date1: number, date2: number): Promise<any> {
        const mesurePdf: Array<any> = [];
        const snapShot = await this.fireDb.list('/' + this.deviceId + '/jsonvaleur')
            .query.orderByChild('time').startAt(date1).once('value');
        if (snapShot.exists()) {
            snapShot.forEach(mesure => {
                if (mesure.val().time <= date2) {
                    mesurePdf.push({
                        temp: mesure.val().temp,
                        hum: mesure.val().hum,
                        time: mesure.val().time
                    });
                }
            });
        }
        return mesurePdf;
    }

    // For history PDF Generator fo the ****** ***** Safran
    async getMesureSafran(internalDevice: string, externalDevice: string, date1: number, date2: number): Promise<any> {
        const mesurePdf: Array<any> = [];
        const snapShotExt = await this.fireDb.list('/' + internalDevice + '/jsonvaleur').query
            .orderByChild('time').startAt(date1).once('value');
        if (snapShotExt.exists()) {
            snapShotExt.forEach(mesure => {
                if (mesure.val().time <= date2) {
                    mesurePdf.push({
                        tempExt: mesure.val().temp,
                        tempInt: null,
                        humExt: mesure.val().hum,
                        humInt: null,
                        time: mesure.val().time
                    });
                }
            });
        }
        const snapShotInt = await this.fireDb.list('/' + externalDevice + '/jsonvaleur').query
            .orderByChild('time').startAt(date1).once('value');
        if (snapShotInt.exists()) {
            snapShotInt.forEach(mesure => {
                if (mesure.val().time <= date2) {
                    // Find closest time to exterior meure and push it there!
                    const closestIndex = this.FindClosest(mesurePdf, 'time', mesure.val().time);
                    mesurePdf[closestIndex] = {
                        tempExt: mesurePdf[closestIndex].tempExt,
                        tempInt: mesure.val().temp,
                        humExt: mesurePdf[closestIndex].humExt,
                        humInt: mesure.val().hum,
                        time: mesure.val().time
                    };
                }
            });
        }
        mesurePdf.sort((n1, n2) => {
            return n1.time - n2.time;
        });
        return mesurePdf;
    }


    // For history PDF generator (2AS: 'Moyennes par heure')
    async getMeasureHourly(date1: number, date2: number): Promise<any> {
        const measurePdf: Array<any> = [];
        const dataObject = {};
        const snapShot = await this.fireDb.list('/' + this.deviceId + '/jsonvaleur')
            .query.orderByChild('time').startAt(date1).once('value');
        if (snapShot.exists()) {
            snapShot.forEach(measure => {
                if (measure.val().time <= date2) {
                    const dateOfMeasure = new Date(measure.val().time);
                    const hour = dateOfMeasure.getHours();
                    const day = dateOfMeasure.getDate();
                    const month = dateOfMeasure.getMonth();
                    const year = dateOfMeasure.getFullYear();
                    const millisHour = new Date(year, month, day, hour).getTime();
                    if (dataObject[millisHour + ''] == null) {
                        dataObject[millisHour + ''] = {};
                        dataObject[millisHour + '']['hum'] = measure.val().hum;
                        dataObject[millisHour + '']['temp'] = measure.val().temp;
                    } else {
                        dataObject[millisHour + '']['hum'] =
                            (measure.val().hum + dataObject[millisHour + '']['hum']) / 2;
                        dataObject[millisHour + '']['temp'] =
                            (measure.val().temp + dataObject[millisHour + '']['temp']) / 2;
                    }
                }
            });
        }
        for (const keyMillis of Object.keys(dataObject)) {
            measurePdf.push({
                temp: dataObject[keyMillis]['temp'],
                hum: dataObject[keyMillis]['hum'],
                time: +keyMillis
            });
        }
        return measurePdf;
    }




    // for history PDF generator (door state)
    async getDoorSate(date1: number, date2: number): Promise<any> {
        const doorPdf: Array<any> = [];
        const snapShot = await this.fireDb.list('/' + this.deviceId + '/LAST/door/datesChanges')
            .query.orderByKey().startAt('' + date1).once('value');
        if (snapShot.exists()) {
            // console.log("history pdf generator snapshot exists ! ")
            snapShot.forEach(ds => {
                if (+(ds.key) <= date2) {
                    doorPdf.push({
                        date: this.toDate(+(ds.key)),
                        value: (ds.val() === 0) ? 'Fermée' : 'Ouverte',
                    });
                }
            });
        }
        return doorPdf;
    }

    // for notifications PDF generator
    async getNotificationsForPdf(date1: number, date2: number): Promise<any> {
        const notifPdf: Array<any> = [];
        const snapShot = await this.fireDb.list('/' + this.deviceId + '/notification').query.orderByChild('date')
            .startAt(date1).once('value');
        if (snapShot.exists()) {
            snapShot.forEach(notif => {
                if (notif.val().date <= date2) {
                    notifPdf.push({
                        date: this.toDate(notif.val().date),
                        message: notif.val().message,
                        title: notif.val().title,
                        fixed: notif.val().fixed == null ? '' : notif.val().fixed
                    });
                }
            });
        }
        return notifPdf;
    }




    // return the auth instance
    authUser() {
        return this.fireAuth;
    }



    // signIn to firebase
    async signIn(mail: string, password: string): Promise<any> {
        let error = '';
        await this.fireAuth.signInWithEmailAndPassword(mail, password).then(
            (success) => {
                this.router.navigate(['home']).then(() => {
                    window.location.reload();
                });
            }
        ).catch((err) => {
            error = err.message;
        });
        return error;
    }



    signOut() {
        this.getAllKey().then(keyArray => {
            // Get token from cookies
            const token = this.getCookie('token');
            // console.log('signOut: token: ' + token);
            if (token) {
                // Token exist, delete it from every device
                // console.log('Signing out, deleting the token: ' + token);
                for (const key of keyArray) {
                    this.fireDb.database.ref('/' + key + '/token').orderByValue().equalTo(token)
                        .once('value').then(snapShot => {
                            if (snapShot.exists()) {
                                snapShot.forEach(tokenSnap => {
                                    tokenSnap.ref.remove();
                                });
                            }
                        });
                }
                this.setCookie('token', null, 30);
            }

            // Signing out
            this.fireAuth.signOut().then(() => {
                this.router.navigate(['/login']);
            });
        });

    }


    getId() {
        // 2AS work only in fictive device "ESP2635206COPY"
        return this.deviceId;
    }

    getCurrentSetting(): Observable<any> {
        return this.fireDb.object('/' + this.deviceId + '/setting').valueChanges();
    }



    async getChartData1(): Promise<any> {
        const chartRef = this.fireDb.database.ref('/' + this.deviceId + '/jsonvaleur');
        const snapshot = await chartRef.once('value');
        if (snapshot.exists()) {
            snapshot.forEach((jsonValue) => {
                // var temp = jsonValue.val().temp;
                // var hum = jsonValue.val().hum;
            });
        }
    }

    // get door state
    async getDoorChart(): Promise<any> {
        const timeBefore = (new Date()).getTime() - 86400000;
        const snap = await this.fireDb.list('/' + this.deviceId + '/LAST/door/datesChanges')
            .query.orderByKey().startAt('' + timeBefore).once('value');
        const doorData = [];
        if (snap.exists()) {
            snap.forEach(change => {
                doorData.push({
                    date: +(change.key),
                    state: change.val()
                });
            });
            return doorData;
        } else { return null; }
    }

    // get the door state of the begining of chart data (exactly before timeBefore)
    async getFirstDoorState(): Promise<any> {
        const timeBefore = (new Date()).getTime() - 86400001;
        let firstDoorStateChart: number;
        const snap = await this.fireDb.list('/' + this.deviceId + '/LAST/door/datesChanges')
            .query.orderByKey().endAt('' + timeBefore).limitToLast(1).once('value');
        if (snap.exists()) {
            snap.forEach(el => {
                firstDoorStateChart = el.val();
            });
            return firstDoorStateChart;
        } else {
            // console.log("no first door state !")
            return 0; // supposed to be closed
        }
    }


    /*
    getDeviceCalibrationTemp(key: string) {
        return this.fireDb.object('/' + key + '/setting' + '/calibrationTemp').valueChanges();
    }

    getDeviceCalibrationHum(key: string) {
        return this.fireDb.object('/' + key + '/setting' + '/calibrationHum').valueChanges();
    }

    async getCalibrationTempAndHum(key: string) {
        let calibTempHum: { cT: number, cH: number };
        await this.fireDb.database.ref('/' + key + '/setting').once('value').then(snapShotSettings => {
            calibTempHum = {
                cT: snapShotSettings.val().calibrationTemp == null ? 0 : snapShotSettings.val().calibrationTemp,
                cH: snapShotSettings.val().calibrationHum == null ? 0 : snapShotSettings.val().calibrationHum
            };
        });
        return calibTempHum;
    }
    */


    /** updated on 06/04/2021 to match 2AS calibration request ('Date d'actualisation étalonnage') */
    async getCalibrationTempAndHum2(key: string) {
        const calibTempHum = { cT: 0, cH: 0 };
        const timeNow = new Date().getTime();
        await this.fireDb.database.ref('/' + key + '/setting').once('value').then(snapShotSettings => {
            if (snapShotSettings.exists()) {
                calibTempHum.cT = snapShotSettings.val().calibrationTemp == null ? 0 : snapShotSettings.val().calibrationTemp;
                calibTempHum.cH = snapShotSettings.val().calibrationHum == null ? 0 : snapShotSettings.val().calibrationHum;
                if (this.devices2ASList.includes(key)) {
                    /** this is 2AS device ! */
                    const settings2AS = snapShotSettings.val()['2AS'];
                    if (settings2AS != null && settings2AS.calibration != null && settings2AS.calibration.date != null) {
                        if (timeNow < settings2AS.calibration.date) {
                            // still we didn't reach calibration date so calibration is 0
                            calibTempHum.cT = 0;
                            calibTempHum.cH = 0;
                        }
                    }
                }
            }

        });
        return calibTempHum;
    }


    /** Calibration: return observable instead of promise */
    getCalibTempHumObservable(key: string) {
        return from(this.getCalibrationTempAndHum2(key));
    }


    /** Verify user password and delete logs */
    async verifyAndDeleteLogs(password: string) {
        const currentUser = await this.fireAuth.currentUser;
        const userEmail = currentUser.email;
        const signIN = await this.fireAuth.signInWithEmailAndPassword(userEmail, password);

        if (signIN) {
            await this.fireDb.database.ref('/' + this.deviceId + '/jsonvaleur').remove();
        }
        return true;
    }

    /** Verify user password and delete notifications */
    async verifyAndDeleteNotifs(password: string) {
        const currentUser = await this.fireAuth.currentUser;
        const userEmail = currentUser.email;
        const signIN = await this.fireAuth.signInWithEmailAndPassword(userEmail, password);
        if (signIN) {
            await this.fireDb.database.ref('/' + this.deviceId + '/notification').remove();
            await this.fireDb.database.ref('/' + this.deviceId + '/LAST').update({
                newConnectionNotifs: 0,
                newNotifs: 0
            });
        }
        return true;
    }


    /** Get device frequency */
    async getDeviceFreq(dId: string) {
        let freq = null;
        await this.fireDb.database.ref(`/${dId}/setting/f`).once('value').then(fSnap => {
            freq = fSnap.val();
        });
        return freq;
    }


    /***************************************** */
    // ALL NEXT METHODS ARE FOR HOME MAIN SCREEN.
    /***************************************** */

    async getAllKey(uId?: string): Promise<any> {
        if (!uId) {
            const snap = await this.fireDb.database.ref('/users/' + this.getUserId()).once('value');
            const keyTab = [];
            if (snap.exists()) {
                snap.forEach(id => {
                    // Some times is array and i don't know why!!
                    if (!Array.isArray(id.val())) {
                        keyTab.push(id.val());

                    }
                });
            }
            return keyTab;
        } else {
            const snap = await this.fireDb.database.ref().child('/users/' + uId).once('value');
            const keyTab = [];
            if (snap.exists()) {
                snap.forEach(id => {
                    // Some times is array and i don't know why!!
                    if (!Array.isArray(id.val())) {
                        keyTab.push(id.val());

                    }
                });
            }
            return keyTab;
        }

    }

    getSynchronisation(key: String) {
        return this.fireDb.object('/' + key + '/LAST' + '/lastValue' + '/date').valueChanges();
    }
    getCurrentTemp(key: String) {
        return this.fireDb.object('/' + key + '/LAST' + '/lastValue' + '/temp').valueChanges();
    }
    getCurrentHum(key: String) {
        return this.fireDb.object('/' + key + '/LAST' + '/lastValue' + '/hum').valueChanges();
    }
    getMaxTemp(key: String) {
        return this.fireDb.object('/' + key + '/setting' + '/seuilMaxTemp').valueChanges();
    }
    getMinTemp(key: String) {
        return this.fireDb.object('/' + key + '/setting' + '/seuilMinTemp').valueChanges();
    }
    getMaxHum(key: String) {
        return this.fireDb.object('/' + key + '/setting' + '/seuilMaxHum').valueChanges();
    }
    getMinHum(key: String) {
        return this.fireDb.object('/' + key + '/setting' + '/seuilMinHum').valueChanges();
    }
    getNotificationsNumber(key: String): Observable<any> {
        return this.fireDb.object('/' + key + '/LAST/newNotifs').valueChanges();
    }

    getNotificationsConnectNumber(key: String): Observable<any> {
        return this.fireDb.object('/' + key + '/LAST/newConnectionNotifs').valueChanges();
    }
    getDoorState(key?: String) {
        if (key) {
            return this.fireDb.object('/' + key + '/LAST' + '/door/value').valueChanges();
        } else {
            return this.fireDb.object('/' + this.deviceId + '/LAST' + '/door/value').valueChanges();
        }
    }
    getDeviceName(key: String) {
        return this.fireDb.object('/' + key + '/setting' + '/deviceName').valueChanges();
    }


    temporary() {
        this.fireDb.database.ref('/users').update({
            'f': 'userId'
        });
    }

    // Save device order to firebase
    saveOrder(orderedDevices: any) {
        this.fireDb.database.ref('/users/' + this.getUserId()).set(orderedDevices).catch(err => {
            console.error(err);
        });
    }



    /***************************************** */
    // ALL PREVIOUS METHODS ARE FOR HOME MAIN SCREEN.
    /***************************************** */



    fixNotification(fixText, notifId) {
        return this.fireDb.database.ref('/' + this.deviceId + '/notification/' + notifId).update({
            'fixed': fixText === '' ? ' ' : fixText
        });
    }

    minusNotification() {
        return this.fireDb.database.ref('/' + this.deviceId + '/LAST' + '/newNotifs').transaction(nbNotifs => {
            if (nbNotifs !== 0) {
                return nbNotifs - 1;
            }
        });
    }


    isSameMinute(millis1: number, millis2: number) {
        const date1 = new Date(millis1);
        const date2 = new Date(millis2);
        if (date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth()
            && date1.getDate() === date2.getDate() && date1.getHours() === date2.getHours()
            && date1.getMinutes() === date2.getMinutes()) {
            return true;
        }
        return false;
    }


    /** Find closest dateProperty to millis in array of measure */
    FindClosest(arr: Array<any>, dateProperty: string, millis: number) {
        let closestIndex = 0;
        let curr = arr[0];
        let diff = Math.abs(millis - curr[dateProperty]);
        for (let index = 0; index < arr.length; index++) {
            const newDiff = Math.abs(millis - arr[index][dateProperty]);
            if (newDiff < diff) {
                diff = newDiff;
                curr = arr[index];
                closestIndex = index;
            }
        }
        return closestIndex;
    }

    // Just for TEST!
    getTheLastMaxTemperatureSeuilNotification() {
        return this.fireDb.database.ref('/' + this.deviceId + '/notification').orderByChild('type').equalTo(0).limitToLast(1).once('value');
    }


    /** ===================================================
     * Cookies functions, because ngx-cookies won't work
     * ====================================================== */
    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        const expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }

    getCookie(cname) {
        const name = cname + '=';
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }

    checkCookie(cname): boolean {
        const cValue = this.getCookie(cname);
        if (cValue && cValue.length !== 0) {
            return true;
        } else {
            return false;
        }
    }
    /** ===========================
     * END cookies
     ============================== */
}
